const uiTranslations = {
  cookie_consent: {
    message:
      "Vi bruker informasjonskapsler for å sikre at du får den beste opplevelsen på nettstedet vårt.",
    learn_more: "Les mer",
    accept: "Aksepter",
    decline: "Avslå",
  },
}

export default uiTranslations
